import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  /** Seconds of delay, used to stagger sibling reveals. */
  delay?: number;
  className?: string;
}

/**
 * Pronounced fade-in + 40px slide-up as the element enters the viewport. Runs once.
 */
export function Reveal({
  children,
  delay = 0,
  className
}: RevealProps) {
  const reduced = useReducedMotion();
  if (reduced) return <div className={className} data-id="element-264" data-mp="2js143l15af5u">{children}</div>;
  return <motion.div className={className} initial={{
    opacity: 0,
    y: 40
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-8% 0px -8% 0px'
  }} transition={{
    duration: 0.95,
    ease: [0.16, 1, 0.3, 1],
    delay
  }} data-id="element-265" data-mp="2nriaqhsb5icl">
      {children}
    </motion.div>;
}